// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer__container--rpHPM","Links":"Footer__Links--1Ejm6","SelectBox":"Footer__SelectBox--1RZ-g","CopyRight":"Footer__CopyRight--25O0f"};